export default function() {
    const self = this

    if (self.$store.state.user.roles) {
        self.checkAccess()
    }

    self.$root.$on('sessionChecked', () => {
        self.checkAccess()
    })

    self.loadCarts()
}
